import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function WRSupplement() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px] overflow-hidden" data-id="element-2364">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2365">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-2366">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-2367">
            <div className="relative w-full aspect-square rounded-lg overflow-hidden shadow-2xl" data-id="element-2368">
              <img src="https://cdn.magicpatterns.com/uploads/qgTJCbQfPKQXfaZFExyFc6/AdobeStock_257206406-5.webp" alt="Be CLINICAL Treatment - Be HAPPY" className="w-full h-full object-cover" data-id="element-2369" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-2370">
            <span className="text-white uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2371">
              Be SEEN
            </span>

            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-2372">
              SUPPLEMENT FOR OPTIMAL RESULTS
            </h2>

            <div className="space-y-6 text-white text-base leading-[1.8] font-body" data-id="element-2373">
              <p data-id="element-2374">
                For even more dramatic results, combine this treatment with our
                BeTOX Facial, dermal fillers or a BBL. Dr. Fiona explains,{' '}
                <span className="italic" data-id="element-2375">
                  'If you get a BBL treatment every three months followed
                  immediately by a wrinkle relaxer, you will thank me in two
                  weeks!'
                </span>
              </p>
              <p data-id="element-2376">
                And don't forget the proper skin care products!{' '}
                <span className="italic" data-id="element-2377">
                  'Don't just have wrinkle-free skin, have glowing, healthy
                  skin! At a minimum, make sure you're using topical vitamin C
                  every morning, a good moisturizer with peptides, and always
                  wear an excellent sunscreen with at least 50 SPF,'
                </span>{' '}
                says Dr. Fiona.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}